// extracted by mini-css-extract-plugin
export default {"cellTable":"PatientTable_cellTable__WXBZc"};